import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, normalizeStyle as _normalizeStyle, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9191b03a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "list-title" }, "请选择极飞科技新农贷合作伙伴", -1))
const _hoisted_2 = { class: "list-wrap" }
const _hoisted_3 = { class: "info-wrap" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-item" }, [
  /*#__PURE__*/_createElementVNode("div", null, "年利率"),
  /*#__PURE__*/_createElementVNode("div", null, "3.2%"),
  /*#__PURE__*/_createElementVNode("div", null, "季度付息/到期还本")
], -1))
const _hoisted_5 = { class: "info-wrap" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-item" }, [
  /*#__PURE__*/_createElementVNode("div", null, "年利率"),
  /*#__PURE__*/_createElementVNode("div", null, "5.99-8.99%"),
  /*#__PURE__*/_createElementVNode("div", null, "按月还息，到期还本/等额本息，按月还款")
], -1))
const _hoisted_7 = { class: "info-wrap" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-item" }, [
  /*#__PURE__*/_createElementVNode("div", null, "年利率"),
  /*#__PURE__*/_createElementVNode("div", null, "5.99%"),
  /*#__PURE__*/_createElementVNode("div", null, "按月还息，到期还本/等额本息，按月还款")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "* 选择贷款渠道前，请先向当地经销商了解贷款政策！", -1))

import { useStore } from 'vuex'
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import { clearToast, showConfirmModal, showToastLoading } from '@/utils/tools'
import { setNFBottomOperatorBar } from '@/utils/tools'
import { getXingbangWxMiniProgramUrlScheme } from '@/apis/agricultura-loan'
import { AgriculturalLoanContractListRouteName } from '@/defination/constant'
import appHost from '@/utils/app'
import AppHeader from '@/components/Header.vue'
import IconYixin from '@/assets/agricultural-loan/yixin-icon.png'
import IconArrowRightWrap from '@/components/icon/IconArrowRightWrap.vue'
import IconNonghang from '@/assets/agricultural-loan/nonghang-icon.png'
import IconXingbang from '@/assets/agricultural-loan/xingbang-icon.png'
import { commonErrorHandle } from '@/utils/error-handle'


export default /*#__PURE__*/_defineComponent({
  __name: 'app-list',
  setup(__props) {

const $router = useRouter()
const vueStore = useStore()
const userInfo = vueStore.state.userInfo
const appMobile = ref('')

const { setBottomHandle } = setNFBottomOperatorBar()
function toNonghang() {
  $router.push({
    name: AgriculturalLoanContractListRouteName,
  })
}
async function showLoanConfirmModal() {
  try {
    await showConfirmModal({
      title: '提示',
      message:
        '您即将离开当前页面，前往第三方公司页面申请贷款业务。如确认继续，请点击【确认跳转】；如无需此项服务，请点击【暂不前往】返回原页面。借款行为需审慎决策，相关责任由您自行承担。',
      confirmButtonText: '确认跳转',
      cancelButtonText: '暂不前往',
      className: 'nongfu-dialog-confirm-class nongfu-dialog-message-center',
      showCancelButton: true,
    })
  } catch (error) {
    console.log('error', error)
    return Promise.reject(error)
  }
}
async function toYixinHandle() {
  try {
    await showLoanConfirmModal()
  } catch (error) {
    return
  }
  // 跳转到易信
  // window.location.href = 'https://m.yixin.com/loan/agricultural-loan'
  appHost.openNewPage({
    title: '易鑫',
    url: process.env.VUE_APP_WEB_URL_YIXIN,
    showTopBar: true,
  })
}
// 兴邦菜单处理
async function toXingBang() {
  try {
    await showLoanConfirmModal()
  } catch (error) {
    return
  }
  showToastLoading()
  try {
    const url = await getXingbangWxMiniProgramUrlScheme()
    window.location.href = url
    clearToast()
  } catch (error) {
    commonErrorHandle(error)
  }
}

function onLeftClick() {
  appHost.goAppBack()
}
setBottomHandle()

async function initMobile() {
  const appInfo = await appHost.getAppBaseInfo()
  appMobile.value = appInfo.phone || ''
}

initMobile()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, {
      title: "新农贷",
      isReturnLeftEvent: "",
      onLeftClick: onLeftClick
    }),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(IconArrowRightWrap, {
        class: "item-wrap",
        showArrow: "",
        fillColor: "gray",
        onClick: toNonghang
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", {
              class: "icon",
              style: _normalizeStyle({
            backgroundImage: 'url(' + _unref(IconNonghang) + ')',
          })
            }, null, 4)
          ])
        ]),
        _: 1
      }),
      _createVNode(IconArrowRightWrap, {
        class: "item-wrap",
        showArrow: "",
        fillColor: "gray",
        onClick: toYixinHandle
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", {
              class: "icon",
              style: _normalizeStyle({
            backgroundImage: 'url(' + _unref(IconYixin) + ')',
          })
            }, null, 4)
          ])
        ]),
        _: 1
      }),
      _createVNode(IconArrowRightWrap, {
        class: "item-wrap",
        showArrow: "",
        fillColor: "gray",
        onClick: toXingBang
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", {
              class: "icon",
              style: _normalizeStyle({
            backgroundImage: 'url(' + _unref(IconXingbang) + ')',
          })
            }, null, 4)
          ])
        ]),
        _: 1
      })
    ]),
    _hoisted_9
  ], 64))
}
}

})